import { useSelector } from 'react-redux'

import { calculateSectionScore } from '~/pages/anatomyV2/libs/calculateSectionScore'
import SectionCompleteTemplate from '~/pages/anatomyV2/libs/components/SectionCompleteTemplate'
import { SECTION_5_SCORING } from '~/pages/anatomyV2/libs/scoredSections'
import { selectAnswers } from '~/shared/store/common/selects'
import { TPageProps } from '~/shared/types/commonTypes'

const NEXT_SECTION_NUMBER = 6
const POINTS_GOAL =
  SECTION_5_SCORING.scoredPageIds.length * SECTION_5_SCORING.pointsPerQuestion

const Section5CompleteAnatomyV2 = (props: TPageProps) => {
  const answers = useSelector(selectAnswers)
  const pointsEarned = calculateSectionScore(SECTION_5_SCORING, answers)

  return (
    <SectionCompleteTemplate
      {...props}
      nextSectionNumber={NEXT_SECTION_NUMBER}
      titleI18nKey="onboarding.section5Complete.title"
      subtitleI18nKey="onboarding.section5Complete.subtitle"
      pointsEarned={pointsEarned}
      pointsGoal={POINTS_GOAL}
      question="Section 5 complete"
    />
  )
}

export default Section5CompleteAnatomyV2
